import { apiCall } from "./Interceptor";

const NATIONALITY_ALL = "/nationality/getAll/public";

const getNationality = async () => {
    const response = await apiCall.get(NATIONALITY_ALL);
    return response;
}

export default {
    getNationality,
};
